import { Collapse, Grid, Tooltip } from "@material-ui/core";
import { Alert } from "@mui/material";
import DropdownFilter from "components/DropdownFilter";
import { useEffect, useState } from "react";
import { arrayToObject } from "utils/object-util";
import { ConditionType } from "../formBuilderConsts";
import { FormConditionsStyles } from "./FormConditionsStyle";
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

export const FormConditionsContainer = ({ onQuestionChange, questionsForConditions, currentQuestion }) => {
    const classes = FormConditionsStyles();
    const [expanded, setExpanded] = useState(true);

    return (
        <Grid className={classes.conditionsContainer} >
            <Grid container direction='row' alignContent='center' spacing={1}>
                {!(!!questionsForConditions?.length) && <Alert severity="warning">There are no questions you can base a condition on</Alert>}

                {/* 
                <Grid item className={classes.expandIcon}>
                    {expanded ? <ExpandLessIcon
                        onClick={() => setExpanded(!expanded)}
                        disabled={!(!!questionsForConditions.length)}
                    />
                        : <ExpandMoreIcon
                            onClick={() => setExpanded(!expanded)}
                            disabled={!(!!questionsForConditions.length)}
                        />}</Grid> */}
                <Grid item container alignItems='center' className={classes.addConditions}>Only show question when:
                    <Tooltip
                        componentProp={{
                            tooltip: {
                                sx: {
                                    padding: '1em',
                                }
                            }
                        }}
                        title={<div className={classes.tooltip}>Define conditions for when this question should be displayed based on answers to previous questions.
                            <p> If no condition is specified, the question will always be shown.</p>
                            <p>The previous questions need to be saved before they can be used in conditions.</p></div>}
                        placement="right-end">
                        <InfoOutlinedIcon className={classes.icon} />
                    </Tooltip> </Grid>

            </Grid>

            <FormConditions
                expanded={expanded}
                questionsForConditions={questionsForConditions}
                currentQuestion={currentQuestion}
                onQuestionChange={onQuestionChange}
            />
        </Grid >
    )
}
const FormConditions = ({ expanded, questionsForConditions, currentQuestion, onQuestionChange }) => {
    const classes = FormConditionsStyles();

    const [selectedQuestion, setSelectedQuestion] = useState();
    const [selectedValues, setSelectedValues] = useState([]);
    const [questionValues, setQuestionValues] = useState([]);

    const formQuestionsLookup = arrayToObject(questionsForConditions);

    useEffect(() => {
        if (selectedQuestion) {
            let values = formQuestionsLookup[selectedQuestion]?.values || [];
            let toUse = values.map((v, index) => ({ id: v.value, name: v.value }));
            setQuestionValues(toUse);
        }
    }, [selectedQuestion]);

    useEffect(() => {
        if (!!currentQuestion?.questionConditionList?.[0]) {
            let condition = currentQuestion?.questionConditionList?.[0];
            let questionId = condition?.questionId
            let values = JSON.parse(condition?.values) ?? [];
            setSelectedQuestion(questionId);
            setSelectedValues(values);
        }
    }, [currentQuestion]);

    return (
        <Collapse in={expanded} timeout="auto" unmountOnExit>
            <Grid container direction='row' style={{ paddingTop: '1em' }}>
                <Grid item xs={5} style={{ marginRight: '1em' }}>
                    <div className={classes.label}>Selected question is:</div>
                    <DropdownFilter
                        values={questionsForConditions
                            ?.filter(q => q.id > 0 && q.id != currentQuestion?.id)
                            ?.map(q => ({ id: q.id, name: q.question }))}
                        value={selectedQuestion}
                        onSelect={(value) => {
                            setSelectedQuestion(value?.id);
                            setSelectedValues([]);
                            const condition = [{
                                questionId: value?.id,
                                values: JSON.stringify(selectedValues),
                                conditionType: ConditionType.QUESTION
                            }];
                            onQuestionChange({
                                ...currentQuestion,
                                questionConditionList: condition
                            });
                        }}
                        showEmpty
                        shrink
                        withTypeAhead
                        className={classes.selectWhite}
                    />
                </Grid>
                <Grid item xs={5}>
                    <div className={classes.label}>Selected question values are:</div>
                    <DropdownFilter
                        values={questionValues}
                        value={selectedValues}
                        onSelect={(values) => {
                            setSelectedValues(values);
                            const condition = [{
                                questionId: selectedQuestion,
                                values: JSON.stringify(values),
                                conditionType: ConditionType.QUESTION
                            }];
                            onQuestionChange({
                                ...currentQuestion,
                                questionConditionList: condition
                            });
                        }}
                        showEmpty
                        shrink
                        multiple
                        className={classes.selectWhite}
                    />
                </Grid>
            </Grid>
        </Collapse >
    )
}

export default FormConditions;